module.exports = __webpack_public_path__ + "static/media/img_fenlei06.6963a398.png";